import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import getters from './getters';
import actions from './actions'

Vue.use(Vuex);

const store = new Vuex.Store({
    state:{
        productDetails: {},
        boxSettings: null,
        categoryToggle: false,
        step: 1,
        substep: 1,
        summaryStep: 1,
        showDateLocation: true,
        bottomToolbarExpanded: false,
        productDialogItem: null,
        productDialogToggle: false,
        screen: 'main',
        replaceable: null,
        //redirect user back to summary page
        nextToSummary: false,
        deliveryArea: 'same_day',
        delivery:{
            full_name: '',
            phone: '',
            location_type: 'office',
            house_number: '',
            company_name:'',
            building_name:'',
            condominium_name: '',
            business_name: '',
            department: '',
            level: '',
            street_address: '',
            city: '',
            province: '',
            zip: '',
            country: 'my',
            delivery_plan: 'delivery',
            delivery_date: null,
            delivery_time: '',
            delivery_instructions: '',
            delivery_fee: 0,
            geo_lat:'',
            geo_long:''
        },
        deliveryDate: null,
        recipientType: "new",
        selectedAddrIndex: 1,
        addToFavourite: false,
        timeslots: null,

        box: [],
        categories: [],
        currentCategory: '',
        selectedPriceRange: 'all',
        giftBoxes: [],
        gifts: null,
        addons: null,
        giftCards: [],
        cardMessage: '',
        selectedCardIndex: null,
        signOff: '',
        addresses: [],
        productAmount: 1,

        showError: false,
        errorMessage: '',

        customerHash: null,
        customerId: null,

    },
    mutations,
    getters,
    actions
})

export default store;